// extracted by mini-css-extract-plugin
module.exports = {"noReportsMatches":"NoReportsMatches_noReportsMatches__19ygq","icon":"NoReportsMatches_icon__THMqB"};